import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import swal from "sweetalert";
import LogoutFunction from "../services/LogoutFunction";

export const deleteFormContactApi = createAsyncThunk(
  "form/contact-delete",
  async (messageId) => {
    const tokenData = await JSON.parse(localStorage.getItem("userData")).token;

    const request = await fetch(
      `${process.env.REACT_APP_VERSEL_API}/api/users/contact_join/delete_contact_us/${messageId}`,
      {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${tokenData}`,
        },
      }
    )
      .then((response) => response.json())
      .then((result) => {
        console.log(result);
        return result;
      })
      .catch((error) => {
        console.log(error);
        return error;
      });
    return request;
  }
);

function formatError(errorResponse) {
  swal("Oops", `${errorResponse}`, "error");
}

const DeleteFromContactSlicer = createSlice({
  name: "form/contact-delete",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  extraReducers: (builder) => {
    builder.addCase(deleteFormContactApi.pending, (state) => {
      state.loading = true;
      state.data = null;
      state.error = null;
    });
    builder.addCase(deleteFormContactApi.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload.message === "jwt expired") {
        state.error = action.payload.message;
        formatError(state.error);
        LogoutFunction();
      } else if (action.payload.data != null) {
        state.data = action.payload.data;
        state.error = null;
      } else {
        state.data = null;
        state.error = "Something went wronge";
        formatError(state.error);
      }
    });
    builder.addCase(deleteFormContactApi.rejected, (state, action) => {
      state.loading = false;
      state.data = null;
      state.error = "Error Invaled Data";
      formatError(state.error);
    });
  },
});

export default DeleteFromContactSlicer.reducer;
